import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { NaturezaComboService } from './natureza-combo.service';
import { ComboBase } from 'src/app/models/comboModel';

@Component({
    selector: 'max-natureza-combo',
    templateUrl: './natureza-combo.component.html'
})
export class NaturezaComboComponent implements OnInit {
    public lista!: ComboBase[];
    public selectedItem!: ComboBase;
    @Input() code: string = "";
    @Input() class!: string;
    @Input() selectedItemForm!: ComboBase;
    @Output() aoLimparSelecionado = new EventEmitter();
    @Output() itemSelecionado = new EventEmitter();

    constructor(private service: NaturezaComboService) { }

    ngOnInit(): void {
        this.code = "";


        if (this.selectedItemForm != null) {
            this.code = this.selectedItemForm.code ? this.selectedItemForm.code : '';
            this.selectedItem = this.selectedItemForm;
        }
        this.getLista();
    }

    getLista() {
        this.service.getLista()
            .subscribe(
                (res) => {
                    if (res) {
                        this.lista = res;
                    }
                },
                err => {
                    console.log(`EtapaList ` + err);
                }
            );
    }

    onClear(event: any) {
        this.aoLimparSelecionado.emit(event);
    }
    onChange(event: any) {
        this.itemSelecionado.emit(event.value);
    }
}